module.exports = __webpack_public_path__ + "img/12.8e25498d.jpg";